/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../../styles/components/pageComponents/dashboard/ActionItemsCard.module.css';

export interface ActionItemCardProps
	extends React.HTMLAttributes<HTMLDivElement> {
	type: string; // Type for styling
	icon: React.ReactNode;
	title: string;
	progressText?: string;
	progressPercent?: number;
	className?: string; // Optional custom class for the card
	titleClassName?: string; // For custom title styling
	layout?: 'value-left' | 'value-right'; // For layout control
}

const ActionItemCard: React.FC<ActionItemCardProps> = ({
	type,
	icon,
	title,
	progressText,
	progressPercent,
	className,
	titleClassName, // Destructure the new prop
	layout = 'value-left', // Destructure with a default value
	...rest
}) => {
	return (
		<div className={`${styles.card} ${className || ''}`} {...rest}>
			<div className={styles.cardTop}>
				{/* Conditionally render the value and icon based on the layout prop */}
				{layout === 'value-right' ? (
					<>
						<div
							className={`${styles.iconContainer} ${styles[type]}`}
						>
							{icon}
						</div>
						{/* <span className={styles.value}>{value}</span> */}
					</>
				) : (
					<>
						{/* <span className={styles.value}>{value}</span> */}
						<div
							className={`${styles.iconContainer} ${styles[type]}`}
						>
							{icon}
						</div>
					</>
				)}
			</div>
			<div className={styles.cardBottom}>
				{/* Apply the custom titleClassName to the h3 element */}
				<h3 className={`${styles.title} ${titleClassName || ''}`}>
					{title}
				</h3>
				{progressText && (
					<p className={styles.progressText}>
						{/* SVG icon */}
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="17"
							height="12"
							viewBox="0 0 17 12"
							fill="none"
						>
							<path
								d="M15.811 0.880127L5.49854 11.1926L0.811035 6.50513"
								stroke="#147B58"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
						{progressText}
					</p>
				)}
				{progressPercent !== undefined && (
					<div className={styles.progressBarContainer}>
						<div
							className={styles.progressBarFill}
							style={{ width: `${progressPercent}%` }}
						></div>
					</div>
				)}
			</div>
		</div>
	);
};

export default ActionItemCard;
